{
  "en": {
    "levels": {
      "actions": {
        "add_customer": "Add customer",
        "cancel": "Undo",
        "changeLevel": "Change level",
        "changeTargetGroup": "Change Target Group",
        "delete": "Delete",
        "removeCustomer": "Detach customer",
        "requestUnits": "Request units",
        "save": "Save"
      },
      "building": "Building",
      "customers": "Customers",
      "descriptions": {
        "mupCantDelete": "It seems that you still have units inside this project. In order to delete the project, we recommend you to first delete the units. This way, we are 100% sure that the project can be deleted.",
        "mupCantDeleteDeactivate": "An alternative to deleting the project is to deactivate it. This way, all information will be preserved for future use. Do you want to deactivate this project?"
      },
      "labels": {
        "activity": "Activity",
        "aftercare": "Aftercare",
        "allLevels": "All levels",
        "contacts": "Contacts",
        "conversations": "Conversations",
        "decisions": "Decisions",
        "deleteProject": "Are you sure you want to delete {project_name}",
        "deleteProjectDisclaimer": "Deleting this project will result in the permanent loss of all data and content. This action is irreversible. As an alternative, consider deactivating the project to preserve all information for future use. Please proceed with caution.",
        "deleteWarning": "Be careful! Deleting this level will delete all underlying levels, documents, announcements, FAQS and tasks related to this level.",
        "documents": "Documents",
        "download": "Download {level_name}",
        "generatingExport": "Generating export",
        "hide": "Hide",
        "information": "Information",
        "installment": "Financials",
        "milestones": "Milestones",
        "multiple_selection": "Multiselect",
        "mupCantDelete": "Oh-no, this action is not possible!",
        "needMoreUnits": "Need more units?",
        "reachedMax": "You have created the unit that is assigned to this project. | You have reached the {count} units that are assigned to this project.",
        "reachedMaxRundle": "You have reached your limit of 1 active unit. | You have reached your limit of {count} active units.",
        "requestMoreUnits": "Contact the Ziggu team if you want to request more active units.",
        "settings": "Project settings",
        "sharedWith": "Shared with ",
        "showForLevel": "Show {object} for level",
        "spaces": "Spaces",
        "surveys": "Surveys",
        "tickets": "Conversations",
        "todos": "Tasks",
        "todos_v2": "Tasks v2",
        "willBeAssigned": "Available for everyone in",
        "willBePublished": "Will be shown to everyone in",
        "willBeUploaded": "Will be uploaded to"
      },
      "lot": "Plot",
      "phase": "Phase",
      "project": "Project",
      "tooltip": {
        "unit_available": "Unit is still available",
        "unit_reserved": "Unit is reserved",
        "unit_sold": "Unit is sold"
      },
      "unit": "Unit"
    }
  }
}
